var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonSimpleScandinavian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PersonSimpleScandinavian"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 9C20.6569 9 22 7.65685 22 6C22 4.34315 20.6569 3 19 3C17.3431 3 16 4.34315 16 6C16 7.65685 17.3431 9 19 9Z",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 16.0001C6 16.0001 13 9.00006 17 12.7001C19.2375 14.7626 21 18.0001 26 18.0001",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3125 12.175L9 29",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 29V22L13.6875 18.2125",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M25.4697 18.1709L21.4697 29.1709",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M5.25191 28.9466C5.22239 29.3597 5.5334 29.7186 5.94656 29.7481C6.35973 29.7776 6.71858 29.4666 6.74809 29.0534L5.25191 28.9466ZM6.25191 14.9466L5.25191 28.9466L6.74809 29.0534L7.74809 15.0534L6.25191 14.9466Z",
    fill: "#444F60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSimpleScandinavian);
export default __webpack_public_path__ + "static/media/PersonSimpleScandinavian.d171a3a6a5ad7064d32157cba667c87e.svg";
export { ForwardRef as ReactComponent };